import React from 'react';

interface Props {
    title: string|null|undefined
}

function PageHeading({title}: Props) {

    return (

        <div className="mb-0">
            <div className="row align-items-center">
                <div className="col-lg">
                    <h4 className="page-title mb-0 pl-1">{title}</h4>
                </div>

            </div>
        </div>

    );
}

export default PageHeading;